// URL base del API. Las pantallas importan BASE_BACKEND_URL desde auth.
import { getAccessToken } from './tokenStore'

export const BASE_BACKEND_URL = process.env.REACT_APP_BACKEND_URL

export const getApiHeaders = () => {
  const token = getAccessToken()
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }

  if (token) {
    headers.Authorization = `Bearer ${token}`
  }

  return headers
}
